/* global localStorage: false*/
import React from 'react';
import { connect } from 'react-redux';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import PropTypes from 'prop-types';
import PasswordField from './PasswordField';
import Loading from './Loading';

import { ErrorDiv, Input, PwErrorDiv } from '../assets/constants/styles';
import NotificationSystem from 'react-notification-system';
import { AddNotification, NotificStyle } from '../assets/constants/notification';
import {
  validatePassword,
  passwordRegex,
  passwordErrorMsgs,
  passwordUIPrompts,
  validationRegex,
  validationErrorMsgs,
  formFieldsPlaceHolders,
} from 'insured-ui-state-mgmt/dist/util/Validations';
import NumberFormat from 'react-number-format';

class RegistrationScreen1 extends React.Component {
  constructor(props) {
    super(props);

    const fields = localStorage.getItem('InputFields');
    let fName = '',
      lName = '',
      email = '',
      phone = '';
    if (fields !== null) {
      localStorage.removeItem('InputFields');
      const fieldObj = JSON.parse(fields);
      fName = fieldObj.firstName;
      lName = fieldObj.lastName;
      email = fieldObj.email;
      phone = fieldObj.phone;
    }
    this.state = {
      loading: false,
      confirmPasswordVerified: false,
      passwordLengthVerified: false,
      passwordDigitVerified: false,
      passwordCharSmallCapsVerified: false,
      firstName: fName,
      lastName: lName,
      email: email,
      phone: phone,
      password: '',
      confirmPassword: '',
      agreeToTerms: false,
    };
    this.notificationSystem = React.createRef();
    this._onTextChange = this._onTextChange.bind(this);
    this._onPhoneNumberChange = this._onPhoneNumberChange.bind(this);
    this._onPasswordChanged = this._onPasswordChanged.bind(this);
    this._onConfirmPasswordChanged = this._onConfirmPasswordChanged.bind(this);
    this._createAccount = this._createAccount.bind(this);
  }

  componentDidUpdate(prevProps) {
    /*const {stateService} = this.props.transition.router;
    stateService.go('registrationScreen2');*/
    if (!Object.is(this.props.response, prevProps.response)) {
      if (this.props.response.code === 0) {
        console.log('Navigating to screen 2');
        this.setState({ loading: false });
        this.props.transition.router.stateService.go('registrationScreen2', {}, { location: false });
      } else if (this.props.response.code) {
        this._addNotification('error', 'Error', this.props.response.message);
        this.setState({ loading: false });
      }
    }
  }

  /*componentDidUpdate(prevProps) {
    if (!Object.is(this.props.response, prevProps.response)) {
      this.setState({ loading: false });
      if (this.props.response.code === 0) {
        // ToDo: login logic here
        this.props.transition.router.stateService.go(
          'registrationScreen2',
          {},
          { location: false }
        );
      } else if (this.props.response.code === 2) {
        this._addNotification('error', 'Api Error', "User created but email couldn't be send.");
        this.props.transition.router.stateService.go(
          'registrationScreen2',
          {},
          { location: false }
        );
        // ToDo: Call For Resend email or just show the error message
      } else {
        this._addNotification(
          'error',
          'Api Error: ' + this.props.response.code,
          this.props.response.message
        );
      }
    }
  }*/

  _onConfirmPasswordChanged(event) {
    const text = event.target.value.trim();
    this.setState({ confirmPassword: text });
    const { password } = this.state;
    if (text.length === 0 || password.length === 0) {
      return;
    }

    if (password !== text) {
      this.setState({
        confirmPasswordVerified: false,
      });
    } else {
      this.setState({
        confirmPasswordVerified: true,
      });
    }
  }

  _onPasswordChanged(event) {
    const text = event.target.value.trim();
    this.setState({ password: text });
    const passwordValidation = validatePassword(text);
    this.setState({
      passwordLengthVerified: passwordValidation.passwordLength,
      passwordDigitVerified: passwordValidation.passwordDigit,
      passwordCharSmallCapsVerified: passwordValidation.passwordCharSmallCaps,
    });
    //confirmPassword does not match
    const { confirmPassword } = this.state;

    if (text.length === 0 || confirmPassword.length === 0) {
      return;
    }

    if (confirmPassword !== text) {
      this.setState({
        confirmPasswordVerified: false,
      });
    } else {
      this.setState({
        confirmPasswordVerified: true,
      });
    }
  }

  _createAccount = event => {
    event.preventDefault();
    const registrationDetail = {};
    Array.from(event.target.elements).map(element => {
      if (element.name === 'agreeToTerms') {
        registrationDetail[element.name] = element.value === 'on';
      } else if (element.name === 'confirmPassword') {
        registrationDetail[element.name] = element.value === event.target.elements.password.value;
      } else {
        registrationDetail[element.name] = element.value;
      }
    });

    console.log(`form value: ${JSON.stringify(registrationDetail, null, 2)}`);
    if (
      !registrationDetail.firstName ||
      registrationDetail.firstName === '' ||
      !registrationDetail.firstName.match(validationRegex.shortNameRegex)
    ) {
      this._addNotification('error', 'Input Error: First Name', validationErrorMsgs.shortNameRegex);
      return;
    }
    if (
      !registrationDetail.lastName ||
      registrationDetail.lastName === '' ||
      !registrationDetail.lastName.match(validationRegex.nameRegex)
    ) {
      this._addNotification('error', 'Input Error: Last Name', validationErrorMsgs.nameRegex);
      return;
    }
    if (
      !registrationDetail.email ||
      registrationDetail.email === '' ||
      !registrationDetail.email.match(validationRegex.emailRegex)
    ) {
      this._addNotification('error', 'Input Error: Email', validationErrorMsgs.emailRegex);
      return;
    }
    registrationDetail.phone = this.state.phone;
    if (
      !registrationDetail.phone ||
      registrationDetail.phone === '' ||
      !registrationDetail.phone.match(validationRegex.phoneRegex)
    ) {
      this._addNotification('error', 'Input Error: Phone', validationErrorMsgs.phoneRegex);
      return;
    }

    if (!this.state.password || this.state.password === '' || this.state.password.match(passwordRegex.whiteSpaces)) {
      this._addNotification('error', 'Input Error: Password', passwordErrorMsgs.whiteSpaces);
      return;
    }
    if (!this.state.passwordLengthVerified) {
      this._addNotification('error', 'Input Error: Password', passwordErrorMsgs.minLength);
      return;
    }
    if (!this.state.passwordDigitVerified) {
      this._addNotification('error', 'Input Error: Password', passwordErrorMsgs.digitRegex);
      return;
    }
    /* if (!this.state.passwordSymbolVerified) {
      this._addNotification('error', 'Input Error: Password', passwordErrorMsgs.symbolRegex);
      return;
    }*/
    if (!this.state.passwordCharSmallCapsVerified) {
      this._addNotification('error', 'Input Error: Password', passwordErrorMsgs.characterRegex);
      return;
    }
    if (!this.state.confirmPasswordVerified) {
      this._addNotification('error', 'Input Error: Confirm Password', passwordErrorMsgs.confirmPasswordFailed);
      return;
    }

    if (!registrationDetail.agreeToTerms) {
      this._addNotification('error', 'Input Error: Terms', validationErrorMsgs.termsOfUse);
      return;
    }

    this.setState({ loading: true }, () => {
      console.log('Loading Set');
    });
    registrationDetail.postalCode = '';
    this.props.registerAccount(registrationDetail);
  };

  _addNotification = (notificLevel, messageTitle, messageBody) => {
    AddNotification(this.notificationSystem.current, notificLevel, messageTitle, messageBody);
  };
  _onTextChange(event) {
    const name = event.target.name;
    /* if (name !== 'agreeToTerms') { */
    this.setState({ [name]: event.target.value });
    /* } */
  }
  _onPhoneNumberChange(value) {
    this.setState({ phone: value });
  }

  _showTermOfUse = () => {
    const { email, firstName, lastName, phone } = this.state;
    localStorage.setItem('InputFields', JSON.stringify({ email, firstName, lastName, phone }));
    this.props.transition.router.stateService.go('termOfUse', {}, { location: false });
  };

  render() {
    const { loading } = this.state;
    return (
      <div>
        <NotificationSystem ref={this.notificationSystem} style={NotificStyle} />
        {loading && <Loading show={loading} />}
        {!loading && (
          <div className="row">
            <br />
            <form className="col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1" onSubmit={this._createAccount}>
              <div className="form-group">
                <Input
                  className="form-control"
                  maxLength="30"
                  minLength="1"
                  name="firstName"
                  onChange={this._onTextChange}
                  placeholder={formFieldsPlaceHolders.firstName}
                  required="required"
                  type="text"
                  value={this.state.firstName}
                />
              </div>
              <div className="form-group">
                <Input
                  className="form-control"
                  maxLength="30"
                  minLength="3"
                  name="lastName"
                  onChange={this._onTextChange}
                  placeholder={formFieldsPlaceHolders.lastName}
                  required="required"
                  type="text"
                  value={this.state.lastName}
                />
              </div>
              <div className="form-group">
                <Input
                  className="form-control"
                  maxLength="75"
                  name="email"
                  onChange={this._onTextChange}
                  placeholder={formFieldsPlaceHolders.email}
                  required="required"
                  type="email"
                  value={this.state.email}
                />
              </div>
              <div className="form-group">
                <NumberFormat
                  className="form-control"
                  format="###-###-####"
                  isNumericString={true}
                  mask="_"
                  name="phone"
                  onValueChange={values => {
                    const { value } = values;
                    this._onPhoneNumberChange(value);
                  }}
                  placeholder={formFieldsPlaceHolders.phone}
                  required="required"
                  value={this.state.phone}
                />
              </div>
              <PasswordField
                name="password"
                onChange={this._onPasswordChanged}
                placeholder={formFieldsPlaceHolders.password}
                value={this.state.password}
              />
              <PasswordField
                name="confirmPassword"
                onChange={this._onConfirmPasswordChanged}
                placeholder={formFieldsPlaceHolders.confirmPassword}
                value={this.state.confirmPassword}
              />
              <div className="form-group">
                <ErrorDiv accepted={this.state.passwordLengthVerified}>{passwordUIPrompts.minLength}</ErrorDiv>
                <ErrorDiv accepted={this.state.passwordDigitVerified}>{passwordUIPrompts.digitRegex}</ErrorDiv>
                <ErrorDiv accepted={this.state.passwordCharSmallCapsVerified}>
                  {passwordUIPrompts.characterRegex}
                </ErrorDiv>
                {/*<ErrorDiv accepted={this.state.passwordSymbolVerified}>{passwordUIPrompts.symbolRegex}</ErrorDiv>*/}
                {!this.state.confirmPasswordVerified && (
                  <PwErrorDiv>{passwordUIPrompts.confirmPasswordFailed}</PwErrorDiv>
                )}
                <ErrorDiv>{passwordUIPrompts.passwordNotCloseToUsername}</ErrorDiv>
              </div>
              <div className="form-group">
                <label className="form-check-label" htmlFor="agreementTerm">
                  <input
                    checked={this.state.agreeToTerms}
                    className="form-check-input"
                    id="agreementTerm"
                    name="agreeToTerms"
                    onChange={this._onTextChange}
                    required="required"
                    type="checkbox"
                  />
                  &nbsp;&nbsp;&nbsp; I agree to the{' '}
                </label>
                <a data-senna-off="true" href="javascript:;" onClick={this._showTermOfUse}>
                  &nbsp;&nbsp;Terms of use
                </a>
              </div>
              <input className="btn btn-primary pull-right" type="submit" value="Create Account" />
            </form>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  account: state.account.registrationDetails,
  response: state.account.response,
});
const mapDispatchToProps = {
  /*setAccountInfo: accountOperations.registerUser_1,*/
  registerAccount: accountOperations.registerUser,
};

RegistrationScreen1.propTypes = {
  account: PropTypes.object,
  registerAccount: PropTypes.func,
  response: PropTypes.object,
  /*setAccountInfo: PropTypes.func,*/
  transition: PropTypes.object,
  /* Was Causing
  Warning: Failed prop type: RegistrationScreen1: prop type `transition` is invalid; it must be a function, usually from the `prop-types` package, but received `object`.
  transition: {
    router: {
      stateService: {
        go: PropTypes.func,
      },
    },
  }, */
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationScreen1);
